<template>
	<div id="planner-app" class="bg-blue-100 pb-4" :key="props.keyUpdater">
		<Overlay
			:position="'absolute'"
			:open="store.state.loading"
			:color="''"
			:maxOpacity="1"
			:contentTimeout="110"
			:classes="'loader'"
		>
			<div v-if="store.state.loading">
				<!-- <div class="loader position-fixed"></div> -->
			</div>
		</Overlay>

		<div v-if="store.state.productUnavailable && !store.state.activePrestations">
			<OopsBanner />
		</div>
		<div
			v-else
			id="planner-main-wrapper"
			class="container px-0 px-md-3 bg-blue-100"
		>
			<div v-if="!store.state.activePrestations" class="col-12 px-0">
				<div class="container px-0 text-center">
					<h2>
						<span class="title-2 text-grey-800">{{
							store.state.content.planner_planVacation
						}}</span>
					</h2>
				</div>
			</div>
			<template v-if="availableTransportPackCodes.length > 0">
				<TransportSwitch v-if="!store.state.activePrestations && locale !== 'en_US'"></TransportSwitch>
				<TrainTimeLine v-if="isTransportPackageSelected && locale === 'fr_FR'" />
			</template>
			<Search v-if="!store.state.activePrestations"></Search>
			<Result></Result>
			<Summary v-if="!store.state.activePrestations"></Summary>
		</div>

		<ErrorMessage :text="errorText" @close="handleErrorMessageClose" />
	</div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, onMounted, watch } from "vue";
//import store from "@/vue/planning/store/store";
import documentReady from "@/vue/planning/logic/documentReady";
import useLocale from "@/vue/composables/useLocale";
import transportPackCode from "@/config/transportPackCode";

// components
import Search from "@/vue/planning/components/search.vue";
import Result from "@/vue/planning/components/result.vue";
import Summary from "@/vue/planning/components/summary.vue";
import TransportSwitch from "@/vue/planning/components/transportSwitch.vue";
import TrainTimeLine from "@/vue/planning/components/trainTimeLine.vue";
import OopsBanner from "@/vue/planning/components/oopsBanner.vue";
import Overlay from "@/vue/common/overlay.vue";
import ErrorMessage from "@/vue/planning/components/common/errorMessage.vue";

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes";

import { useStore } from "vuex";
const store = useStore();


interface Props {
	keyUpdater: string;
}
const props = defineProps<Props>();

const locale = useLocale();

const isTransportPackageSelected = computed(() => {
	return transportPackCode.includes(store.state.packCode);
});

// computed
const errorText: ComputedRef<string> = computed(() => {
	const val = store.state.content[store.state.errorMessageOpen];
	return val;
});


// methods
const handleErrorMessageClose = () => {
	store.commit("setErrorMessageOpen", "");
};

onMounted(async () => {
	await documentReady(store);
	window.addEventListener("closeMonCompteModal", async () => {
		await documentReady(store);
	});

	store.commit("setScreenType", window.screenSizeManager.screenType);
	window.addEventListener("screenTypeChange", () => {
		store.commit("setScreenType", window.screenSizeManager.screenType);
	});

	const triggerResize = () => {
		window.dispatchEvent(new Event('resize'));
	};

	triggerResize(); // initial
	window.addEventListener('orientationchange', triggerResize);
	// window.addEventListener('resize', triggerResize);
});

// watch
watch(
	() => store.state.bodyOverflowHidden,
	(newValue: boolean) => {
		if (newValue) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	}
);
</script>

<style scoped>
@media (max-width: 1500px) {
	#planner-main-wrapper{
		max-width: 1200px;
	}
}
</style>
